module.exports = __webpack_public_path__ + "img/right.5b072248.png";